import onRequestUpdate from './onRequestUpdate'

const onClear = (hotel, key) => {
  // CarrierWaveの仕様でremoev_xxx(boolean型)なパラメータをリクエストに送るとDBとファイルを削除してくれる
  onRequestUpdate(hotel.set(`remove_${key}_url`, true))
}

export default onClear
